var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "formkit:arrowright"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6309 10H6.75586C6.23086 10 5.81836 9.56 5.81836 9C5.81836 8.44 6.23086 8 6.75586 8H23.6309C24.1559 8 24.5684 8.44 24.5684 9C24.5684 9.56 24.1559 10 23.6309 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.9434 17C18.8204 17.0016 18.6985 16.9757 18.5855 16.9241C18.4725 16.8724 18.3708 16.7961 18.2871 16.7C17.9121 16.3 17.9121 15.68 18.2871 15.28L24.1934 8.97999L18.2871 2.67999C17.9121 2.27999 17.9121 1.65999 18.2871 1.25999C18.6621 0.859991 19.2434 0.859991 19.6184 1.25999L26.1809 8.25999C26.5559 8.65999 26.5559 9.27999 26.1809 9.67999L19.6184 16.68C19.4309 16.88 19.1871 16.98 18.9621 16.98L18.9434 17Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.12f6c490836f48f2ec997154cd867546.svg";
export { ForwardRef as ReactComponent };